const CONTENT_SOURCE_MAPS_ZERO_WIDTH_CHARS = /[\u200B-\u200D\uFEFF]/g;

export const cleanContentfulId = <T extends string | undefined>(value: T): T =>
    typeof value === 'string' ? (value.replace(CONTENT_SOURCE_MAPS_ZERO_WIDTH_CHARS, '') as T) : value;
